import { Box, HStack, Text } from "@chakra-ui/react";
import { Field, FormInput, FormSelect, FormSwitch, RemoveIconButton } from "../../ui/inputs";
import { createEmptySetRule, SET_AGGREGATION } from "../../models/scoringModel";
import { pointsColor } from "../../helpers/pointsColor";

const SetRulesEditor = ({ config, onChange, labels, disabled = false }) => {
    const list = config.setRules ?? [];
    const update = (i, patch) => onChange({ setRules: list.map((r, idx) => (idx === i ? { ...r, ...patch } : r)) });
    const remove = (i) => onChange({ setRules: list.filter((_, idx) => idx !== i) });
    const add = () => onChange({ setRules: [...list, createEmptySetRule()] });

    const aggregationOptions = Object.values(SET_AGGREGATION).map((v) => ({
        value: v,
        label: labels.setAggregationOptions[v],
    }));

    return (
        <Box display="flex" flexDirection="column" gap={3}>
            <HStack gap={3} align="flex-end">
                <Box flex={1}>
                    <Text fontSize="xs" color="text.grey" fontWeight={600} textTransform="uppercase" letterSpacing="wider" mb={1}>
                        {labels.setAggregation}
                    </Text>
                    <FormSelect
                        value={config.setAggregation}
                        onChange={(v) => onChange({ setAggregation: v })}
                        options={aggregationOptions}
                        disabled={disabled}
                    />
                </Box>
                <FormSwitch
                    label={labels.capAtMaxScore}
                    checked={!!config.capAtMaxScore}
                    onChange={(v) => onChange({ capAtMaxScore: v })}
                    disabled={disabled}
                />
            </HStack>

            <Text fontSize="xs" color="text.grey" fontWeight={600} textTransform="uppercase" letterSpacing="wider">
                {labels.valueRulesTitle}
            </Text>
            {list.map((rule, i) => (
                <HStack key={i} gap={3} align="flex-end">
                    <Box flex={2}>
                        <Field label={labels.valueColumn}>
                            <FormInput
                                disabled={disabled}
                                value={rule.value}
                                onChange={(e) => update(i, { value: e.target.value })}
                            />
                        </Field>
                    </Box>
                    <Box flex={1}>
                        <Field label={labels.pointsColumn}>
                            <FormInput
                                type="number"
                                disabled={disabled}
                                value={rule.points ?? ""}
                                color={pointsColor(rule.points, config.maxScore)}
                                onChange={(e) => update(i, { points: e.target.value === "" ? null : Number(e.target.value) })}
                            />
                        </Field>
                    </Box>
                    <FormSwitch
                        label={labels.disqualifyColumn}
                        checked={!!rule.disqualify}
                        onChange={(v) => update(i, { disqualify: v })}
                        disabled={disabled}
                        size="sm"
                    />
                    <RemoveIconButton onClick={() => remove(i)} disabled={disabled} />
                </HStack>
            ))}
            <Box
                as="button"
                type="button"
                onClick={add}
                disabled={disabled}
                alignSelf="flex-start"
                px={3}
                py={1.5}
                borderRadius={6}
                border="1px dashed"
                borderColor="border.primary"
                fontSize="xs"
                color="text.grey"
                opacity={disabled ? 0.5 : 1}
                cursor={disabled ? "not-allowed" : "pointer"}
                _hover={disabled ? undefined : { borderColor: "purple.400", color: "purple.300" }}
            >
                {labels.addSetRule}
            </Box>
        </Box>
    );
};

export default SetRulesEditor;
